import MasonryGrid from '../components/MasonryGrid';

export default class StaticCollectionsList {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.$masonry = this.$el.find('[data-masonry-grid]');
    this.masonryGrid = null;

    if (this.$masonry.length) {
      this.masonryGrid = new MasonryGrid({
        $el: this.$masonry,
      });
    }
  }

  onSectionUnload() {
    if (this.masonryGrid) {
      this.masonryGrid.unload();
    }
  }
}
